import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'

const propTypes = {
  alt: PropTypes.string,
  path: PropTypes.string.isRequired,
  image_uri: PropTypes.string.isRequired,
}

function ImageLink({ alt = '', path, image_uri }) {
  return (
    <a href={path}>
      <img src={image_uri} alt={alt} />
    </a>
  )
}

ImageLink.propTypes = exact(propTypes)

export default pure(ImageLink)
